import {
  commonValidationSchemas,
  createValidationSchema,
} from 'infrastructure/functions';

import type { TSchema } from 'infrastructure/functions';

export const patientConditionValidationSchema = (
  showTrackingPlatform?: boolean,
) =>
  createValidationSchema({
    code: commonValidationSchemas.string({ required: true }),
    diagnoseGuid: commonValidationSchemas.string({ required: true }),
    description: commonValidationSchemas.string({ required: true }),
    trackingPlatform: showTrackingPlatform
      ? commonValidationSchemas.string({ required: true })
      : commonValidationSchemas.string(),
  });

export type Values = TSchema<
  ReturnType<typeof patientConditionValidationSchema>
>;
